import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-clockwise-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", d: "M14.045 6.203A6 6 0 1 1 8.5 2.5" }),
        React.createElement("path", { fill: "currentColor", strokeLinejoin: "round", d: "M10.5 2.5 8.5.75v3.5z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
